module.exports = __webpack_public_path__ + "static/media/overview.3a71f3e0.svg";